<h2 mat-dialog-title>
  <div class="share-profile-card-btn" (click)="shareProfileCard()">
    <span class="icon icon-Share"></span>
    <span class="text">{{ 'landing.button.share_profile_card' | translate }}</span>
  </div>
  <span class="icon-close icon-Cross" mat-dialog-close></span>
</h2>

<mat-dialog-content>
  <img [src]="profileCardImg" [alt]="'landing.text.profile_card_alt' | translate" />
</mat-dialog-content>
